

export const UserPermissions = 
    {
        'CanRead': false,
        'CanInsert': false,
        'CanUpdate': false,
        'CanDelete': false,
        'CanExecute': false,
        'CanViewAttachments': false,
        'CanAddAttachments': false,
        'CanDeleteAttachments': false,
    }
    